import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Spinner = () => (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <span className="loading loading-spinner loading-lg text-blue-800"></span>
    </div>
  );

const ProtectedRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const token = localStorage.getItem('authToken');

        if (!token) {
          setIsAuthenticated(false);
          return;
        }

        const response = await axios.post(
          '/api/verify-user',
          {},
          {
            headers: {
              Authorization: token, 
              'X-CSRFToken': window.CSRF_TOKEN || '',
            },
            withCredentials: true,
          }
        );

        const { role } = response.data;

        if (role === 'admin') {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    verifyUser();
  }, []);

  if (isAuthenticated === null) {
    return <Spinner />;
  }

  return isAuthenticated ? element : navigate('/login');
};

export default ProtectedRoute;
